import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
import { AuthService } from './auth.service';
import decode from 'jwt-decode';
import { TokenStorageService } from './token-storage.service';


@Injectable()
export class RoleGuardService implements CanActivate {

    constructor(public auth: AuthService, public router: Router, private tokenStorage: TokenStorageService) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {    // this will be passed from the route config
        // on the data property
        const expectedRole = route.data.expectedRole;
        const token = this.tokenStorage.getToken();    // decode the token to get its payload
        if (token) {
          const tokenPayload = decode(token);

          //if (!this.auth.isAuthenticated() || !expectedRole.includes(tokenPayload.role)) {
          if (!this.auth.isAuthenticated() || !this.hasRole(expectedRole,tokenPayload.role)) {
              this.router.navigate(['login']);
              return false;
          }
        }else{
            return false;
        }


        return true;
    }

    hasRole(list1,list2):boolean{
      var retorno:boolean = false;

      for(var i = 0; i<list1.length; i++){
        for(var z = 0; z<list2.length; z++){
          if(list1[i]==list2[z]){
            retorno = true;
            break;
          }
        }
        if(retorno)
          break;
      }
      return retorno;
    }
}
